import script from "./CreativePreviewPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreativePreviewPage.vue?vue&type=script&setup=true&lang=ts"

import "./CreativePreviewPage.vue?vue&type=style&index=0&id=36a4bcc0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36a4bcc0"]])

export default __exports__